module.exports = __webpack_public_path__ + "img/submitaudio.efbff377.png";